import type { JSX } from 'react'
import { UseComboboxProps } from 'downshift'
import { IconProps } from '@alto-avios/alto-ui/dist/components/Icon/Icon'

export interface AutoCompleteItemAttributes {
  label: string
  value: string
}

export type AutoCompleteProps<
  TItem extends AutoCompleteItemAttributes = AutoCompleteItemAttributes
> = Omit<
  UseComboboxProps<TItem>,
  | 'inputValue'
  | 'defaultInputValue'
  | 'initialInputValue'
  | 'initialSelectedItem'
  | 'initialActiveIndex'
  | 'id'
  | 'labelId'
  | 'menuId'
  | 'toggleButtonId'
  | 'inputId'
  | 'getItemId'
> & {
  name: string
  label: string
  accessibleLabel?: string
  value?: string
  defaultValue?: string
  note?: string
  error?: string
  children?: React.ReactNode | undefined
  gridArea?: string
  onInputFocus?: (e: React.FocusEvent<HTMLInputElement, Element>, openMenu: () => void) => void
  disabled?: boolean | undefined
  helperMessage?: JSX.Element | undefined
  isRequired?: boolean
  endIconProps?: IconProps
}

export interface AutoCompleteContextValue {
  getOptionProps: (item: any) => any
  highlightedIndex: number
  closeMenu?: () => void
}

export const AUTOCOMPLETE_FIELD_ICON_PROPS: IconProps = {
  iconName: 'magnifying-glass',
  iconSize: '1x',
}

export type LocationOptionProps = AutoCompleteItemAttributes & {
  key?: string
  title: string
  subtitle: string
  icon?: IconProps
}
